import $ from './app/jquery-shim.js';
import Utils from './app/utils.js';
import Accordion from './app/accordion.js';
import Anchor from './app/anchor.js';
import FixedHeader from './app/fixedheader.js';
import HeightLine from './app/heightline.js';
import ResponsiveTable from './app/responsive-table.js';
import Slidebar from './app/slidebar.js';
import Tab from './app/tab.js';
import CurrentNav from './app/current-nav.js';
import ScrollReveal from 'scrollreveal';
import PsCss from 'perfect-scrollbar/css/perfect-scrollbar.css';
import Ps from 'perfect-scrollbar';
import jqueryModal from 'jquery-modal';
import OwlCarousel from 'owl.carousel';
import Url from 'url-parse'
import fontAwesome from 'font-awesome/scss/font-awesome.scss';
import jquerymodalcss from 'jquery-modal/jquery.modal.css';
import OwlCss from 'owl.carousel/dist/assets/owl.carousel.css';
import OwlThemeCss from 'owl.carousel/dist/assets/owl.theme.default.css';

class App {
	constructor() {
		this.Utils = new Utils();
		this.Accordion = new Accordion();
		this.Anchor = new Anchor();
		this.FixedHeader = new FixedHeader();
		this.HeightLine = new HeightLine();
		this.ResponsiveTable = new ResponsiveTable();
		this.Slidebar = new Slidebar();
		this.CurrentNav = new CurrentNav();
		this.Tab = new Tab();

		$(function () {
			window.sr = ScrollReveal();

			if ($(".c-slidebar-menu").length && $(".c-footer-menu__block").length) {
				var $block = $(".c-footer-menu__block").clone()
				$(".c-slidebar-menu").append($block)
			}

			if ($(".c-tabs__navs").length) {
				new Ps($(".c-tabs__navs")[0], {
					wheelSpeed: 2,
					wheelPropagation: true,
					minScrollbarLength: 20
				});
			}
			var clickflag = false;

			$("a").on("click", function (e) {
				var href = $(this).attr("href");
				var _url = new Url(href)
				if (_url.pathname === "/coupon/") {
					e.preventDefault()
					$("#shoplistbuttoncoupon").modal({
						fadeDuration: 200,
						fadeDelay: 0.10
					})
					clickflag = true;
				}
				if (_url.pathname === "/plan/") {
					e.preventDefault()
					$("#shoplistbuttonplan").modal({
						fadeDuration: 200,
						fadeDelay: 0.10
					})
					clickflag = true;
				}
				return true;
			})

			function simplesr(selector, num) {
				if (!num) {
					num = 150;
				}
				$(selector).each(function (key, data) {
					sr.reveal(this, {
						delay: num * key,
						distance: '10px'
					}, 500);
				});
			}

			simplesr('.c-main-menu__block');
			simplesr('.c-bnr-content__block');
			// simplesr('.c-card-box__block', 80);
			sr.reveal('.c-main-visual__text', {delay: 500, distance: "20px"});

			$.modal.defaults = {
				closeExisting: true,    // Close existing modals. Set this to false if you need to stack multiple modal instances.
				escapeClose: true,      // Allows the user to close the modal by pressing `ESC`
				clickClose: true,       // Allows the user to close the modal by clicking the overlay
				closeText: '閉じる',     // Text content for the close <a> tag.
				closeClass: '',         // Add additional class(es) to the close <a> tag.
				showClose: true,        // Shows a (X) icon/link in the top-right corner
				modalClass: 'c-modal',    // CSS class added to the element being displayed in the modal.
				blockerClass: 'c-modal',  // CSS class added to the overlay (blocker).
				// HTML appended to the default spinner during AJAX requests.
				spinnerHtml: '<div class="rect1"></div><div class="rect2"></div><div class="rect3"></div><div class="rect4"></div>',
				showSpinner: true,      // Enable/disable the default spinner during AJAX requests.
				fadeDuration: 400,     // Number of milliseconds the fade transition takes (null means no transition)
				fadeDelay: 1.0          // Point during the overlay's fade-in that the modal begins to fade in (.5 = 50%, 1.5 = 150%, etc.)
			};
			var owls = $('.owl-carousel');
			owls.imagesLoaded(function () {

				$('.c-main-visual__slider').owlCarousel({
					items: 1,
					margin: 0,
					dots: true,
					loop: true,
					nav: false,
					autoplayHoverPause: true,
					autoplay: true,
					autoplaySpeed: 2000,
					center: true,
					animateIn: 'fadeIn',
					animateOut: 'fadeOut'
				});
				$('.c-main-visual__banner').owlCarousel({
					margin: 0,
					dots: true,
					loop: true,
					nav: true,
					autoplayHoverPause: true,
					autoplay: true,
					autoplaySpeed: 1000,
					center: true,
					navText: ['<img src="/wp-content/themes/grandbowl-offcial/dist/assets/images/img-prev.png" />', '<img src="/wp-content/themes/grandbowl-offcial/dist/assets/images/img-next.png" />'],
					responsive: {
						0: {
							autoWidth: false,
							nav: true,
							navText: ['<img src="/wp-content/themes/grandbowl-offcial/dist/assets/images/img-prev.png" />', '<img src="/wp-content/themes/grandbowl-offcial/dist/assets/images/img-next.png" />'],
							items: 1
						},
						980: {
							autoWidth: true,
							nav: true,
							navText: ['<img src="/wp-content/themes/grandbowl-offcial/dist/assets/images/img-prev.png" />', '<img src="/wp-content/themes/grandbowl-offcial/dist/assets/images/img-next.png" />'],
							items: 3
						}
					}
				});
			});
			var win = $(window).innerWidth();
			if (win > 980) {
				return false;
			}
			$('.c-footer-menu__list.is-parent').on('click', function () {
				return false;
			});
			$('.c-footer-menu__list').on('click', function () {
				$(this).toggleClass('is-active');
				$(this).next('.c-footer-menu__submenu').slideToggle();
			});


		});
	}
}

window.GApp = new App();
